export default "__VITE_ASSET__DmsDJIpI__"